import { useEffect, useState } from 'react';
import useClaimsLidLabelList from '../../../redux/hooks/useClaimsLidLabelList';
import FormSelectBox from '../Inputs/FormSelectBox';

const ClaimsLidLabelSelector = ({
  label = 'LID Label',
  placeholder = 'Enter LID Label',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
}) => {
  const [options, setOptions] = useState([]);
  const lidLabelList = useClaimsLidLabelList();

  useEffect(() => {
    if (lidLabelList?.length >= 0) {
      const options = lidLabelList.map((row) => ({
        label: row.lidLabel,
        value: row.lidLabelKey,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [lidLabelList]);

  return (
    <FormSelectBox
      loading={lidLabelList === undefined}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
    />
  );
};

export default ClaimsLidLabelSelector;
